import React, { createContext } from 'react';
import { IAmpPropsTag } from '../../typings/amp';

interface IAmpContext {
  ampProps: IAmpPropsTag[] | undefined;
  isAmp: boolean;
}

interface IAmpPropsProvider {
  children?: JSX.Element;
  value: IAmpContext;
}

const DEFAULTS = { ampProps: undefined, isAmp: false };

export const AmpPropsContext = createContext<IAmpContext>(DEFAULTS);

const AmpPropsContextProvider: React.FC<IAmpPropsProvider> = ({ value, children }) => {
  return <AmpPropsContext.Provider value={value}>{children}</AmpPropsContext.Provider>;
};

export default AmpPropsContextProvider;
